import React, { useState } from 'react';
import {urlApiProd} from '../utiles';
import DateInput from '../../components/DateInput/DateInput';
import moment from 'moment';
import { Modal, Button, Spinner, Badge } from 'react-bootstrap';

const AgregarSolicitudInterna = ({ puertos, clientes, cerrar }) => {
    const [formData, setFormData] = useState({
        codigo: '',
        id_cliente: '',
        id_puerto_destino: '',
        freetimedestino: '',
        etd: '',
        cantidad: '',
        requerimientos: '',
        tipo_bl : 'BL Original',
    });
    const [clienteNombre, setClienteNombre] = useState('');
    const [clientesDropdownAbierto, setClientesDropdownAbierto] = useState(false);
const [show, setShow] = React.useState(true);

    const handleClose = () => {setShow(false);
        cerrar();
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChangeUpperCase = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };

    const handleClienteChange = (e) => {
        const nombre = e.target.value;
        setClienteNombre(nombre);
        setClientesDropdownAbierto(true);
        setFormData(prev => ({
            ...prev,
            id_cliente: '',
        }));
    };

    const seleccionarCliente = (cliente) => {
        setClienteNombre(cliente.nombre);
        setFormData(prev => ({ ...prev, id_cliente: cliente.id_cliente }));
        setClientesDropdownAbierto(false);
    };

    const handleClienteKeyDown = (e) => {
        if (e.key === 'Escape') {
            setClientesDropdownAbierto(false);
        } else if (e.key === 'Enter' && clientesDropdownAbierto && clientesFiltrados.length > 0) {
            e.preventDefault();
            seleccionarCliente(clientesFiltrados[0]);
        }
    };

    const clientesFiltrados = clientes.filter(cliente =>
        cliente.nombre.toLocaleLowerCase().includes(clienteNombre.trim().toLocaleLowerCase())
    ).slice(0, 50);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        const puerto = puertos.find(p => p.id_puerto.toString() === formData.id_puerto_destino.toString());
        if (!formData.id_cliente) {
            alert('Seleccione un cliente de la lista');
            return;
        }
        if (!puerto) {
            alert('Seleccione un puerto de destino');
            return;
        }
        const solicitud = {
            ...formData,
            codigo: `${puerto.nombre.toUpperCase().substring(0, 3)}${moment().format('YYYYMMDDHmmss')}`,
            id_cliente: Number(formData.id_cliente),
        };
       // setFormData({ ...formData, ['codigo']: `${puerto.nombre.toUpperCase().substring(0, 3)}${moment().format('YYYYMMDDhhmmss')}` });
        try {
            const response = await fetch(`${urlApiProd}/addsolicitudinterna`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(solicitud)
            });
            if (!response.ok) throw new Error('Error al agregar la solicitud interna');
            alert('Solicitud interna agregada exitosamente');
            cerrar();
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo agregar la solicitud interna');
        }
    };

    const handleRadioChange = value1 => {
        const { name, value } = value1.target;
        setFormData({ ...formData, [name]: value });
      };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Agregar Solicitud Interna</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <form onSubmit={handleSubmit}>
                            <div className="mb-3 position-relative">
                                <label className="form-label" htmlFor="cliente-solicitud-interna">Cliente</label>
                                <input
                                    id="cliente-solicitud-interna"
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    placeholder="Buscar cliente..."
                                    value={clienteNombre}
                                    onChange={handleClienteChange}
                                    onFocus={() => setClientesDropdownAbierto(true)}
                                    onBlur={() => setTimeout(() => setClientesDropdownAbierto(false), 150)}
                                    onKeyDown={handleClienteKeyDown}
                                    role="combobox"
                                    aria-autocomplete="list"
                                    aria-expanded={clientesDropdownAbierto}
                                    aria-controls="clientes-solicitud-interna"
                                    required
                                />
                                {clientesDropdownAbierto && (
                                    <div
                                        id="clientes-solicitud-interna"
                                        className="list-group position-absolute w-100 shadow"
                                        role="listbox"
                                        style={{ top: 'calc(100% + 2px)', left: 0, maxHeight: 220, overflowY: 'auto', zIndex: 1060 }}
                                    >
                                        {clientesFiltrados.length > 0 ? clientesFiltrados.map(cliente => (
                                            <button
                                                key={cliente.id_cliente}
                                                type="button"
                                                className="list-group-item list-group-item-action text-start"
                                                role="option"
                                                onMouseDown={e => e.preventDefault()}
                                                onClick={() => seleccionarCliente(cliente)}
                                            >
                                                {cliente.nombre}
                                            </button>
                                        )) : (
                                            <div className="list-group-item text-muted">No se encontraron clientes</div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Puerto Destino</label>
                                <select
                                    className="form-select"
                                    name="id_puerto_destino"
                                    onChange={handleChange}
                                    value={formData.id_puerto_destino}
                                >
                                    <option value="">Seleccione un Puerto</option>
                                    {puertos
                                        .filter((puerto) => puerto.indicador === 2 || puerto.indicador === 3) // Filtra puertos destino
                                        .map((item) => (
                                            <option key={item.id_puerto} value={item.id_puerto}>
                                                {item.nombre}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">ETD</label>
                                <DateInput name="etd" onChange={handleChange} value={formData.etd} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Free Time Destino</label>
                                <input type="text" className="form-control" name="freetimedestino" onChange={handleChange} value={formData.freetimedestino} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Cantidad de Contenedores</label>
                                <input type="number" className="form-control" name="cantidad" onChange={handleChange} value={formData.cantidad} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Requerimientos Especiales</label>
                                <textarea className="form-control" name="requerimientos" onChange={handleChange} value={formData.requerimientos}></textarea>
                            </div>
                            <div className="radio-buttons">
                                <input type="radio" value="BL Original" name="tipo_bl" onChange={handleRadioChange} defaultChecked/> BL Original
                                <input style={{ marginLeft: '25px' }} type="radio" value="Express Release" name="tipo_bl" onChange={handleRadioChange}/> Express Release
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>Volver</button>
                                <button type="submit" className="btn btn-primary">Guardar</button>
                            </div>
                        </form>
              </Modal.Body>
            </Modal>
    );
}

export default AgregarSolicitudInterna;
        
